module.exports = __webpack_public_path__ + "bfc9fba0811b344d8cbf30d910e9032f.png";